import SectionWrapper from '../components/SectionWrapper';
import ScrollReveal from '../components/ScrollReveal';
import { PROJECT_INFO, TEAM_TAGS } from '../data/mockData';
import { GraduationCap, Globe, Calculator } from 'lucide-react';

// 区块8：团队介绍（简化版）
export default function Section08Team() {
  return (
    <SectionWrapper
      id="team"
      title="团队介绍"
      subtitle={`${PROJECT_INFO.teamSize}人跨学科团队 · 数统+外语 · 华师${PROJECT_INFO.grade}`}
    >
      <ScrollReveal>
        <div className="glass-card max-w-5xl mx-auto text-center mb-10">
          <p className="text-xl lg:text-2xl text-slate-200 leading-relaxed mb-6">
            本项目团队由华中师范大学数学与统计学学院、外国语学院{PROJECT_INFO.grade}学子组成，
            涵盖算法工程、前端架构、数据可视化、教育产品设计及国际化文案等多领域能力。
          </p>
          <p className="text-xl lg:text-2xl text-slate-200 leading-relaxed">
            团队依托数统学院深厚的数理统计建模优势，将聚类分析、回归建模与NLP技术深度融合，
            致力于打造数学师范生培养的数字化基础设施。
          </p>
        </div>
      </ScrollReveal>

      {/* 核心能力标签云 */}
      <ScrollReveal delay={150}>
        <div className="max-w-4xl mx-auto mb-10">
          <h3 className="text-2xl font-bold text-gold text-center mb-6">核心能力矩阵</h3>
          <div className="tag-cloud justify-center">
            {TEAM_TAGS.map((tag, index) => (
              <span key={index}>{tag}</span>
            ))}
          </div>
        </div>
      </ScrollReveal>

      {/* 底部：3个数据卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {[
          { icon: GraduationCap, value: '100%', label: '专业课程覆盖率', desc: '数学教育核心课程全对齐' },
          { icon: Globe, value: '跨学科', label: '数统+外语协作', desc: '算法能力与国际化表达并重' },
          { icon: Calculator, value: '强支撑', label: '数统学院学科支撑', desc: '统计学、回归建模、聚类分析' },
        ].map((item, index) => {
          const Icon = item.icon;
          return (
            <ScrollReveal key={index} delay={200 + 100 * index}>
              <div className="glass-card text-center">
                <Icon className="w-12 h-12 text-gold mx-auto mb-4" />
                <div className="text-3xl font-black text-cyan mb-2">{item.value}</div>
                <div className="text-xl font-bold text-white mb-2">{item.label}</div>
                <div className="text-sm text-slate-400">{item.desc}</div>
              </div>
            </ScrollReveal>
          );
        })}
      </div>
    </SectionWrapper>
  );
}
